import axios from 'axios';
import Crypto from 'crypto-js';
import moment from 'moment';

const useFbPixel = () => {
  const sendEvent = async (eventName, userEmailAddress = null) => {
    const {
      fbVersion = 'v14.0',
      fbPixelId,
      fbAccessToken,
    } = window['appConfig'];

    if (fbPixelId && fbAccessToken) {
      const requestData = {
        data: [
          {
            event_name: `${eventName}`,
            event_time: moment().unix(),
            action_source: `app`,
            user_data: {
              em: [hashVal(userEmailAddress)],
            },
          },
        ],
      };

      await axios.post(
        `https://graph.facebook.com/${fbVersion}/${fbPixelId}/events?access_token=${fbAccessToken}`,
        requestData,
      );
    }
  };

  const hashVal = (val) =>
    !val ? null : Crypto.SHA256(val.toLowerCase()).toString(Crypto.enc.Hex);

  return sendEvent;
};

export default useFbPixel;
